
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

function Calendar() {
    useEffect(() => {
    const loadScript = (src) =>
    new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });

    const initCalendar = async () => {
    try {
      // Load jQuery first
    //  await loadScript("https://ajax.googleapis.com/ajax/libs/jquery/1.12.4/jquery.min.js");
      // Then load hp-calendar plugin
    //  await loadScript("https://ibron.innovaatik.ee/js/hp-calendar-min.js");

      // Now HPCalendar is defined
      const urlParams = new URLSearchParams(window.location.search);
      let lang = urlParams.get("lang") || "et";

      window.$("#redirect").prop("href", "https://einblau.ee/backend/api/hp-api-client.php?request=manage&lang=" + lang);

      window.$("#hp-calendar").HPCalendar({
        strings: "et",
        info_container: window.$(".hp-calendar-info"),
        api: "https://einblau.ee/backend/api/hp-api-client.php",
        clinic_filter: "",
        default_service: "",
        getNextIfNothing: true,
      });

      window.$("#lang").change(function () {
        const selectedLang = window.$(this).val();
        window.location.search = `?lang=${selectedLang}`;
      });
    } catch (err) {
      console.error("Failed to load scripts:", err);
    }
  };

  initCalendar();
  }, []);
    return (
        <div>
            <div style={{width:"500px"}}>
                <div id="hp-calendar" className="hp-calendar"></div>
                <div className="hp-calendar-info"></div>
            </div>
            <div>
                <a href="https://einblau.ee/backend/api/hp-api-client.php?request=manage" id="redirect">Halda visiite</a>
            </div>
        </div>

    )
}

export default function Hero() {

    return (
      
        <div className='main'>
            <Container>
                <h1 style={{marginBottom:"2.5rem"}}><strong>Broneeri aeg</strong></h1>

                


                <div style={{display:"flex", justifyContent:"center"}}>
                  {Calendar()}
                </div>
                    

            </Container>
        </div>
    );
}